export enum EPublishingStatusColorMapper {
	DRAFT = 'red',
	PUBLISHED = 'green',
}

export enum PublishingStatusEnum {
	DRAFT = 1,
	PUBLISHED = 2,
	CLOSED = 3,
	CANCELLED = 4,
	ARCHIVE = 5,
	UNPUBLISHED = 6,
}

export enum CardsDisplayEnum {
	MAXS_CARDS_TO_DISPLAY = 3,
	CARDS_TO_DISPLAY_IF_MORE_THEN_MAX = 2,
}

export enum EPrintDocumentType {
	INVOICE = 'invoice',
	RECEIPT = 'receipt',
}

export enum EStorageKeys {
	BASE_STORE = 'baseStore',
	ACTIVE_FACILITY_ID = 'active_facility_id',
	BN_TERMINAL = 'bn_terminal',
	TERMINAL_READER_ID = 'terminal_reader_id',
	BN_CART = 'bn_cart',
	BN_SIMULATED_TERMINAL = 'bn_simulated_terminal',
	BN_SIMULATED_TERMINAL_CARD_NUMBER = 'bn_simulated_terminal_card_number',
	CUSTOMER_STORE = 'customerStore',
	EVENT_DATE_OBJECT = 'eventDateObject',
	FACILITYID = 'facilityId',
	FORMATTED_PATH = 'formattedPath',
	MEMBERSHIP_STORE = 'membershipStore',
	TIME_FILTER = 'timeFilter',
	CUSTOMER_DATA = 'customerData',
	SCHEDULE_TIME_FILTER = 'scheduleTimeFilter',
	CART_ID = 'cartId',
}

export const ICON_BTN_HORIZONTAL = 'icon-btn-horizontal';

export enum BOdocumentsEnum {
	INVOICE = 'invoice',
	PAYMENT = 'payment',
}

//todo: rename more genric
export enum CustomPaymentPlanAllocationEnum {
	FIXED = 'fixed',
	PERCENT = 'percent',
}

export enum NoTableRecordsReasonEnum {
	ERROR = 'error',
	EMPTY = 'emptyArray',
}

export enum ButtonTypeEnum {
	Submit = 'submit',
	Button = 'button',
}

export enum BooleanString {
	True = 'true',
	False = 'false',
}

export enum DayPickerEnum {
	MONDAY = 2,
	TUESDAY = 3,
	WEDNESDAY = 4,
	THURSDAY = 5,
	FRIDAY = 6,
	SATURDAY = 7,
	SUNDAY = 8,
}

export enum SeparatorCharEnum {
	Space = ' ',
	Hyphen = '-',
	Underscore = '_',
	Pipe = '|',
	Slash = '/',
}
